// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".labels[data-v-31af48ec]{display:inline;flex-wrap:wrap}.labels .label[data-v-31af48ec]{display:inline-block;margin-top:2px}.taints td[data-v-31af48ec]{padding-top:0}.taints td .tag[data-v-31af48ec]{margin-right:5px;display:inline-block;margin-top:2px}.taints.empty-taints[data-v-31af48ec]{height:0;line-height:0}.taints.empty-taints td[data-v-31af48ec]{padding:0}", ""]);
// Exports
module.exports = exports;
